// Pageview manual por rota para o GA4 (stream admin G-Q0ZMBQ7Q4Y).
//
// O admin é uma SPA (React Router data router): só o boot é um full page
// load. O `gtag('config', ...)` do index.html — agora com
// `send_page_view: false` — não cobre as trocas de rota client-side.
// Em vez de DEPENDER de o Enhanced Measurement ("page changes based on
// browser history events") estar ligado no painel do GA4 (config de
// console, invisível ao código), disparamos o `page_view` nós mesmos a
// cada navegação. Paridade com `capture_pageview: true` do PostHog.
//
// IMPORTANTE — para não contar pageview em DOBRO: o "page changes based
// on browser history events" do Enhanced Measurement do stream admin
// (G-Q0ZMBQ7Q4Y) DEVE ficar DESLIGADO no painel. Com ele ligado + este
// disparo manual, cada navegação SPA contaria 2×. Ver #66.
//
// `window.gtag` só existe em produção: o IIFE do index.html retorna cedo
// em localhost/127.0.0.1/0.0.0.0. Logo, em dev este módulo é no-op.

type Gtag = (...args: unknown[]) => void;

/**
 * Dispara um evento `page_view` no GA4 para o path informado. No-op se o
 * gtag não está carregado (dev/localhost ou bloqueio de rede).
 *
 * Origem: #66 — commit 62fcb1733, 2026-06-20 (GA4 pageview por rota no admin).
 *
 * Usado por: `main.tsx` (`trackCurrentRoute`, no boot e a cada navegação).
 *
 * Dicas: o Enhanced Measurement "page changes based on browser history
 * events" do stream admin tem de ficar DESLIGADO — senão conta em dobro.
 */
export function trackPageview(path: string): void {
  const gtag = (window as unknown as { gtag?: Gtag }).gtag;
  if (typeof gtag !== 'function') return;
  gtag('event', 'page_view', {
    page_path: path,
    page_location: window.location.href,
    page_title: document.title,
  });
}
